const PARAMS_WITH_PREFIX_DELIMITER = '_-_';

export const encodeApiParameters = (
  params: Record<string, any>,
  prefix: string | undefined
) => {
  const newApiParameters: Record<string, any> = {};
  Object.keys(params).forEach((key) => {
    const newKey = prefix
      ? `${prefix}${PARAMS_WITH_PREFIX_DELIMITER}${key}`
      : key;
    newApiParameters[newKey] = params[key];
  });
  return newApiParameters;
};

export const decodeApiParameters = (
  params: Record<string, any>,
  prefix: string | undefined
) => {
  const newApiParameters: Record<string, any> = {};
  Object.keys(params).forEach((key) => {
    let newKey = key;
    const indexOfPrefix =
      prefix && key.indexOf(`${prefix}${PARAMS_WITH_PREFIX_DELIMITER}`);

    if (indexOfPrefix === 0 && prefix) {
      newKey = key.slice(prefix.length + PARAMS_WITH_PREFIX_DELIMITER.length);
      if (params[key] !== '') {
        newApiParameters[newKey] = params[key];
      }
    }
  });

  return newApiParameters;
};
